import React, { Component, Fragment } from "react";
import "./FooData.less";
import http from "../../../utils/api";
import { message,Input,Spin,Icon,Button,Table,Tag,Upload,Checkbox,Pagination,Modal} from "antd";
import EditNotice from "../EditNotice";
import ApproveList from "../ApproveList";
import ApproveProjectList from "../ApproveProjectList";
import UploadFile from "../UploadFile/UploadFile";
const uploadFile = (file, url) => {
  return new Promise((resolve, reject) => {
    let fd = new FormData();
    fd.append("file", file, file.name);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.onload = () => {
      const data = JSON.parse(xhr.response);
      if (xhr.status === 200 && (data.error === 0 || data.error === "0")) {
        const imgUrl = data.data;
        resolve(imgUrl);
      } else {
        reject(data);
      }
    };
    xhr.send(fd);
  });
};
class FooData extends Component {
  state = {
    auth: "",
    keywords:'',
    data:[],
    fileList:[],
    showAdd:false,
    modalVis:false,
    aData:{
      literature_title:null,
      literature_class:null,
      literature_back:null,
    },
    vertified:null,
    classOptions:[],
    pageIndex:0,
    pageSize:10,
    total:0,
    curImage:[],
    uploading:false
  };
  componentDidMount = () => {
    // this.getAuth();
    this.getClass();
    this.getData(0,10);
  };
  // 点击下载按钮
  onDown=(files)=>{
    let n = 0;
    while(n<files.length){
      window.open(files[n].file_url);
      n++;
    }
  }
  // 获取表格数据
  getData=async(page,pagesize,key)=>{
    this.setState({mainLoading:true});
    let p = this.state.pageIndex;
    let ps = this.state.pageSize
    if(page>-1){
      p=page;
    }
    if(pagesize>-1){
      ps=pagesize;
    }
    try{
      let res = await http().getRecordAndSubTables({
        resid:710332311737,
        subresid:710350390906,
        getsubresource: 1,
        pageindex: p,
        pagesize: ps,
        key
        
      });
      if(res.data){
        this.setState({data:res.data.data,total:res.data.total});
      }
      this.setState({mainLoading:false});
    }catch(e){
      this.setState({mainLoading:false});
      message.error(e.message);
      console.log(e.message);
    }
  }
  // 修改文献分类
  onChangeClass=(v)=>{
    let n = 0;
    let str=''
    while(n<v.length){
      str+=v[n]+'，'
      n++;
    }
    str=str.substring(0,str.length-1);
    this.onChange('literature_class',str);
  }
  // 获取文献分类
  getClass=async()=>{
    try{
      let res= await http().getTable({
        resid:710353984876
      })
      let n =0;
      let arr=[];
      while(n<res.data.data.length){
        arr.push({label:res.data.data[n].class_content,value:res.data.data[n].class_content})
        n++;
      }
      this.setState({classOptions:arr});
    }catch(e){
      message.error(e.message);
      console.log(e.message);
    }
  }
  // 表单内容改变
  onChange=(label,v)=>{
    let obj = this.state.aData;
    obj[label]=v;
    this.setState({addData:obj});
  }
  //切换分页
  onChangePage=(cur)=>{
    this.getData(cur-1,this.state.pageSize,this.state.keywords);
    this.setState({pageIndex:cur-1});
  }
  // 分页大小改变
  onShowSizeChange=(cur,pagesize)=>{
    this.getData(cur-1,pagesize,this.state.keywords);
    this.setState({pageIndex:cur-1,pageSize:pagesize});
  }
  getAuth = async () => {
    let res;
    try {
      res = await http().getTable({
        resid: 650458953643,
      });
      this.setState({
        auth:
          res.data &&
          res.data.data &&
          res.data.data[0] &&
          res.data.data[0].auth,
      });
    } catch (error) {
      message.error(error.message);
    }
  };
  // 打开添加窗口
  addNew=()=>{
    this.setState({showAdd:!this.state.showAdd,
      aData:{
        literature_title:null,
        literature_class:null,
        literature_back:null,
        literature_stuation:null
      },
      vertified:null,
      fileList:[],
      loading:false
    });
  }
  // 验证文件名是否存在
  verti=async()=>{
    if(!this.state.aData.literature_title){
      message.error('文献名不能为空',1);
    }else{
      this.setState({loading:true});
      try {
        let res = await http().getTable({
          resid: 710332311737,
          cmswhere:`literature_title = '${this.state.aData.literature_title}'`
        });
       if(res.data){
        if(res.data.data.length>0){
          this.setState({vertified:false,loading:false});
        }else{
          this.setState({vertified:true,loading:false});
        }
       }
      } catch (error) {
        message.error(error.message);
        this.setState({loading:false});
      }
    }
  }
  // 提交文献
  handleAdd=async()=>{
    if(!this.state.aData.literature_class){
      message.error('未选择分类');
      return false;
    }
    if(this.state.fileList.length===0){
      message.error('未上传文献');
      return false;
    }
    this.setState({loading:true});
    try{
      let aData=this.state.aData;
      aData._id=1;
      aData._state='editoradd';
      let subData=[];
      let n = 0;
      let fileList=this.state.fileList
      while(n<fileList.length){
        subData.push({
          resid: 710350390906,
          maindata: {
            file_content:fileList[n].name,
            file_url:fileList[n].url,
            _state: 'editoradd',
            _id: n+1
          }
        })
        n++;
      }
      let data=[{
        resid:710332311737,
        maindata:aData,
        subData
      }]
      let res = await http().saveRecordAndSubTables({
        data
      });
      message.success('添加成功',1)
      this.setState({vertified:null,showAdd:false,fileList:[],keywords:'',pageIndex:0});
      this.getData(0,this.state.pageSize);
    }catch(e){
      message.error(e.message);
      this.setState({loading:false});
    }
  }
    //上传文件
    handleUploadFile = async fileInfo => {
      this.setState({uploading:true});
      const file = fileInfo.file;
      const bucketname = "realsun";
      let type = file.name.split('.');
      type=type[type.length-1];
      const fileUrl = `http://ivf.realsun.me:9001/api/AliyunOss/PutOneImageObject?bucketname=${encodeURIComponent(
        bucketname
      )}&srctype=${encodeURIComponent(type)}`;
      try {
        await uploadFile(file, fileUrl).then(imageUrl => {
          let arr = this.state.fileList;
          arr.push(
            {
              uid: file.uid,
              name: file.name,
              status: 'done',
              url: imageUrl,
            }
          )
          this.setState({
            fileList:arr,
            uploading:false
          });
        });
      } catch (err) {
        this.setState({uploading:false});
        return message.error(err.message);
      }
    };
    // 删除上传的文件
    handleRemoveFile=(v)=>{
      let arr = this.state.fileList;
      let n = 0;
      while(n<arr.length){
        if(arr[n].uid===v.uid){
          arr=arr.splice(n+1,1);
        }
        n++;
      }
      this.setState({fileList:arr})
    }
    //关闭对话框
    handleCancelModal=()=>{
      this.setState({modalVis:false,curImage:[]});
    }
    //打开对话框查看文件
    onView=(record)=>{
      this.setState({modalVis:true,curImage:record[710350390906]});
    }
    //搜索
    handleSearch=()=>{
      this.getData(0,this.state.pageSize,this.state.keywords)
    }
  render() {
    const { auth,pageIndex,uploading,curImage,mainLoading,modalVis,showAdd,keywords,data,aData,classOptions,vertified,fileList} = this.state;
    const columns = [
      {
        title: "文献标题",
        dataIndex: "literature_title",
        key: "literature_title",
        width: 150
      },
      {
        title: "上传医院名",
        dataIndex: "uphospital",
        key: "uphospital",
        width: 150
      },
      {
        title: "阅览文件",
        dataIndex: "uphospital",
        key: "uphospital",
        width: 150,
        render: (text, record) => (
          <span>
            <a
              style={{color:'#1890ff'}}
              onClick={() => {
                this.onView(record);
              }}
            >
              <Icon type='picture' className="icon_viewpic"></Icon>阅览文件
            </a>
          </span>
        )
      },
      {
        title: "文献备注",
        dataIndex: "literature_back",
        key: "literature_back",
        width: 320
      },
      {
        title: "状态",
        dataIndex: "literature_stuation",
        key: "literature_stuation",
        width: 150,
        render: data => {
          return (
            <Tag
              color={
                data === "待确认"
                  ? "#f5f5f5"
                  : '#00a854'
              }
              style={
                {padding:'0 .5rem',color:data === "待确认"?'#999':'#fff'}
              }
            >
              {data}
            </Tag>
          );
        }
      },
      {
        title: "操作",
        key: "action",
        width: 150,
        render: (text, record) => (
          <span>
            <a
              style={{color:'#1890ff'}}
              onClick={() => {
                this.onDown(record[710350390906]);
              }}
            >
              下载
            </a>
          </span>
        )
      }
    ];
    return (
     <div className="foodata">
      {/* 主界面 */}
        <div className="foodata_title">
            文献列表
        </div>
        <Spin spinning={mainLoading}>
          <div className='foodata_toolbar'>
              <Input onKeyDown={(e)=>{
                if(e.keyCode===13){
                  this.handleSearch();
                }
              }} value={keywords} onChange={(v)=>{this.setState({keywords:v.target.value})}} style={{width:240,textIndent:'.5rem'}} placeholder={'请输入关键字'}/>
              <Button onClick={()=>{this.handleSearch();}}>
                <Icon type={'search'}></Icon>
                搜索
              </Button>
              <Button className="foodata_toolbar_btnright" type="primary" onClick={()=>{this.addNew();}}>
                <Icon type={'plus'}></Icon>
                添加新的文献资料
              </Button>
          </div>
          <div className='foodata_table'>
              <Table
                key="1"
                columns={columns}
                dataSource={data}
                pagination={false}
              />
          </div>
          <Pagination current={pageIndex+1} onChange={this.onChangePage} showSizeChanger onShowSizeChange={this.onShowSizeChange} defaultCurrent={1} total={this.state.total} />
        </Spin>
        {/* 添加弹窗 */}
        {
          showAdd?<div className={showAdd?"foodata_addWindow foodata_addWindow_show":"foodata_addWindow"}>
          <div className="foodata_addWindow_backline">
            <Icon type={'left'}  onClick={()=>{this.addNew();}}/>
            添加新的文献
          </div>
          <div className="foodata_addWindow_form">
            <div className="foodata_addWindow_form_name">
              <b>文献名：</b>
              <Input placeholder="输入文献名" style={{width:320,textIndent:'.5rem'}} value={aData.literature_title} onChange={(v)=>{this.setState({vertified:null});this.onChange('literature_title',v.target.value)}}/>
              {vertified?null:<Button loading={this.state.loading} onClick={()=>{this.verti();}}>校验是否重复</Button>}
              {
                !vertified?
                 <span className="foodata_addWindow_form_alert">
                  {vertified===false?'校验未通过':'校验文献名通过后才能进行后续操作'}
                 </span>
                :null
              }
            </div>
            <div className="foodata_addWindow_form_class">
              <b>文献中涉及的食材分类：</b>
              <Checkbox.Group disabled={!vertified} options={classOptions} onChange={this.onChangeClass} />
            </div>
            <div className="foodata_addWindow_form_under">
              <div className="foodata_addWindow_form_under_upload">
                <b>上传文件：</b>
                <Upload
                  name="files"
                  showUploadList={true}
                  customRequest={this.handleUploadFile}
                  fileList={fileList}
                  onRemove={this.handleRemoveFile}
                >
                  <Button disabled={!vertified} icon={uploading?null:'upload'}loading={uploading}>
                   点击上传
                  </Button>
              </Upload>
              </div>
              <div className="foodata_addWindow_form_under_memo">
                <b>备注：</b>
                <Input.TextArea
                  placeholder="输入备注"
                  disabled={!vertified}
                  value={aData.literature_back}
                  onChange={(v)=>{this.onChange('literature_back',v.target.value)}}
                  style={{resize:'none',height:320,width:400,textIndent:'.5rem'}}
                />
              </div>
            </div>
            <Button className="foodata_addWindow_form_handlebtn" onClick={this.handleAdd} type={'primary'} disabled={!vertified} loading={this.state.loading}>
              提交
            </Button>
          </div>
         
        </div>:null
        }
        <Modal
          title="阅览文件"
          visible={modalVis}
          footer={null}
          onCancel={this.handleCancelModal}
          destroyOnClose
        >
          <ul>
            {
              curImage.map(
                (item,key)=>{
                  return(
                    <li key={'modal'+key} style={{marginBottom:5}}>
                      <a target="_blank" href={item.file_url} style={{color:'#1890ff'}}>{item.file_content}</a>
                    </li>
                  )
                }
              )
            }
          </ul>
        </Modal>
     </div>
    );
  }
}

export default FooData;
